import React from 'react';

import { DialogTitle, DialogContent, Typography, TextField, DialogActions, Button, Box } from '@material-ui/core';

import { FilePreview } from './FilePreview';

import DialogManagement, { FormControl } from './DialogManagement';
import { DynamicLoadingButton } from './HelperComponents';

import { FileResponse } from './index';
import { DialogManagementFileProps } from './index.private.interfaces';

export interface RenameFileProps extends DialogManagementFileProps {
  onRename: (file: FileResponse) => Promise<any>;
  onAbort?: (close: boolean) => void;
}

const renameFile = {
  dialog: {
    display: 'flex',
    flexDirection: 'row',
  },
  file: {
    background: 'rgba(0, 0, 0, 0.12)',
    flex: '3 1 200px',
    maxHeight: '400px',
    display: 'inline-flex',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  input: {
    flex: '6 1 0',
    display: 'flex',
    flexDirection: 'column',
  },
} as const;

export const RenameFile = (props: RenameFileProps) => {
  const [currentName, setCurrentName] = React.useState('');

  const abortable = Boolean(props.onAbort);

  const { onRename, onAbort, ...dialogProps } = props;

  return (
    <DialogManagement
      {...dialogProps}
      onClose={() => abortable && props.onAbort?.(false)}
      TransitionProps={{
        onEntering: () => setCurrentName(props.file?.displayName || ''),
      }}
      content={(file) => (
        <FormControl sx={renameFile.dialog}>
          <Box sx={renameFile.file}>
            <FilePreview file={file as FileResponse} disableText />
          </Box>
          <Box sx={renameFile.input}>
            <DialogTitle>Datei beschreiben</DialogTitle>
            <DialogContent>
              <Typography style={{ marginBottom: '16px' }} variant="subtitle2">
                Bitte beschreiben Sie das Bild. Dies dient zur Suche, Navigation und wird zur Darstellung für blinde
                Nutzer verwendet
              </Typography>
              <TextField
                key={file.path}
                label="Beschreibung"
                value={currentName}
                onChange={(event) => setCurrentName(event.currentTarget.value)}
                variant="standard"
                fullWidth
                autoFocus
              />
            </DialogContent>
            <DialogActions>
              {abortable && (
                <Button variant="outlined" onClick={() => onAbort?.(false)}>
                  Abbrechen
                </Button>
              )}
              <DynamicLoadingButton
                color="primary"
                variant="contained"
                disabled={currentName === file?.displayName || !currentName}
                onClick={() => onRename({ ...file, displayName: currentName })}
                key={file.path}
              >
                Umbenennen
              </DynamicLoadingButton>
            </DialogActions>
          </Box>
        </FormControl>
      )}
    />
  );
};
